import { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import UserAccount from "./UserAccount";
import { MdMenu } from "react-icons/md";
import { MyContext } from "../../../context/MyContext";
import withdrawMoney from "../../../images/money.png";
import axios from "axios";
import WithdrawAmount from "../../components/WithdrawAmount";

dayjs.extend(isBetween);

function YourWallet() {
  const {
    getWallet,
    wallet,
    showWithdrawAmountPopUp,
    setShowWithdrawAmountPopUp,
  } = useContext(MyContext);
  const [userAccount, setUserAccount] = useState(true);
  const [transactionTypeAddCoin, setTransactionAddCoin] = useState([]);
  const [transactionPayOut, setTransactionPayOut] = useState([]);
  const [coin, setCoin] = useState(0);
  const [payOut, setPayOut] = useState(0);
  const [dateFilter, setDateFilter] = useState("");
  const [selfPurchased, setSelfPurchases] = useState({
    selfCoin: 0,
    selfPayout: 0,
  });
  const [referralPurchased, setReferralPurchases] = useState({
    payout: 0,
    coins: 0,
  });
  const [groupPurchased, setGroupPurchases] = useState({
    coins: 0,
    payout: 0,
  });
  const token = localStorage.getItem("token");
  const [showUserAccount, setShowUserAccount] = useState(false);
  const userId = localStorage.getItem("userId");
  const [selectedTransactionType, setSelectedTransactionType] = useState("all");
  const {verifyMlmUser}=useContext(MyContext);

  const toggleUserAccount = () => {
    setShowUserAccount((prev) => !prev);
  };

  useEffect(() => {
    async function getUserWallet() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_NODE}user/walletTransactions/${userId}`
        );
        console.log(response);
        const dataWallet = response?.data?.data;
        setSelfPurchases({
          selfCoin: dataWallet[2]?.coins,
          selfPayout: dataWallet[2]?.payout,
        });
        setReferralPurchases({
          payout: dataWallet[1]?.payout,
          coins: dataWallet[1]?.coins,
        });
        setGroupPurchases({
          payout: dataWallet[0]?.payout,
          coins: dataWallet[0]?.coins,
        });
        setCoin(dataWallet?.coins);
        setPayOut(dataWallet?.totalPayout);
        console.log(
          "==============>   transition   ",
          response?.data?.transition
        );
        setTransactionAddCoin(response?.data?.transition);
        setTransactionPayOut(response?.data?.payOutData);
      } catch (err) {
        console.log(err);
      }
    }

    if (userId) getUserWallet();
  }, []);
  const filterByDate = (transactions) => {
    if (dateFilter === "all") return transactions;

    const today = dayjs();
    return transactions.filter((transaction) => {
      const date = dayjs(transaction.coin_add_at || transaction.payout_at);

      switch (dateFilter) {
        case "today":
          return date.isSame(today, "day");
        case "yesterday":
          return date.isSame(today.subtract(1, "day"), "day");
        case "thisWeek":
          return date.isBetween(today.startOf("week"), today.endOf("week"));
        case "thisMonth":
          return date.isBetween(today.startOf("month"), today.endOf("month"));
        case "thisYear":
          return date.isBetween(today.startOf("year"), today.endOf("year"));
        default:
          return true;
      }
    });
  };
  let filteredTransactions = [];
  if (selectedTransactionType === "credited") {
    filteredTransactions = filterByDate();
  } else if (selectedTransactionType === "debited") {
    filteredTransactions = filterByDate(transactionPayOut);
  } else {
    filteredTransactions = filterByDate([
      ...transactionTypeAddCoin,
      ...transactionPayOut,
    ]);
  }

  return (
    <>
      {token ? (
        <div className={`flex gap-4 pt-4 md:pt-2 ${verifyMlmUser ? "lg:pt-[100px]" : "lg:pt-40"}`}>
          {/* Sidebar */}
          <div
            className={`md:block ${
              showUserAccount ? "block" : "hidden"
          } absolute md:relative bg-white shadow-md `}
          >
            <UserAccount showUserAccount={showUserAccount} />
          </div>

          <div className="w-full min-h-screen flex justify-center bg-gradient-to-r from-indigo-200 via-purple-300 to-pink-400">
            <div className="flex justify-end md:hidden">
              <MdMenu
                onClick={toggleUserAccount}
                className="fixed top-25 right-4 text-4xl cursor-pointer border rounded-lg px-1 bg-white shadow-md z-50"
              />
            </div>
            <div className="flex-grow max-w-full mx-auto p-8 mt-4">
              <div className="w-full">
                {/* Date Filter */}
                <div
                  className="relative flex justify-end items-center"
                  onClick={() => setShowWithdrawAmountPopUp(true)}
                >
                  <button className="p-[10px_25px] flex justify-between items-center bg-[#EAB308] text-[#000] rounded-[10px]">
                    Withdraw{" "}
                    <img
                      className="w-[30px] h-[30px]"
                      src={withdrawMoney}
                      alt="withdraw icon"
                    />{" "}
                  </button>
                </div>
                <div className="mb-3 text-sm font-semibold text-gray-800">
                  {/* Desktop View (Radio Buttons) */}
                  <div className="hidden md:flex md:flex-wrap items-start justify-center md:gap-4">
                    {[
                      { label: "All", value: "" },
                      { label: "Today", value: "today" },
                      { label: "Yesterday", value: "yesterday" },
                      { label: "This Week", value: "thisWeek" },
                      { label: "This Month", value: "thisMonth" },
                      { label: "This Year", value: "thisYear" },
                    ].map((filter, index) => (
                      <label
                        key={index}
                        className="flex items-center space-x-2"
                      >
                        <input
                          type="radio"
                          name="dateFilter"
                          value={filter.value}
                          onChange={() => setDateFilter(filter.value)}
                        />
                        <span>{filter.label}</span>
                      </label>
                    ))}
                  </div>

                  {/* Mobile View (Dropdown) */}
                  <div className="md:hidden">
                    <select
                      className="w-full p-2 border outline-none focus:border-pink-400 rounded-md bg-white"
                      value={dateFilter}
                      onChange={(e) => setDateFilter(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>
                      <option value="thisWeek">This Week</option>
                      <option value="thisMonth">This Month</option>
                      <option value="thisYear">This Year</option>
                    </select>
                  </div>
                </div>

                {/* Summary Section */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-3">
                  {[
                    {
                      title: "Available Balance",
                      value: payOut || 0,
                      border: "border-blue-500",
                    },
                    {
                      title: "Total Coins",
                      value: coin || 0,
                      border: "border-yellow-500",
                    },
                    {
                      title: "Withdraw Amount",
                      value: 0,
                      border: "border-green-500",
                    },
                    {
                      title: "Refferal Income",
                      coin: referralPurchased.coins || 0,
                      value: referralPurchased.payout || 0,
                      border: "border-red-500",
                    },
                    {
                      title: "Self Purchase ",
                      coin: selfPurchased?.selfCoin || 0,
                      value: selfPurchased?.selfPayout || 0,
                      border: "border-red-500",
                    },
                    {
                      title: "Group Purchase",
                      coin: groupPurchased.coins || 0,
                      value: groupPurchased.payout || 0,
                      border: "border-red-500",
                    },
                    {
                      title: "Bonus",
                      value: 0,
                      border: "border-red-500",
                    },
                    {
                      title: "Leadership Bonus",
                      value: 0,
                      border: "border-red-500",
                    },
                    {
                      title: "Available Balanced",
                      value: 0,
                      border: "border-red-500",
                    },
                    {
                      title: "Ourmicrolife Pension Fund",
                      value: 0,
                      border: "border-red-500",
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className={`bg-white shadow-lg p-4 rounded-xl flex flex-col items-center border-l-4 relative ${item.border}`}
                    >
      <h2 className="text-sm font-semibold text-gray-800">
        {item.title}
      </h2>
      <p className="text-lg font-bold text-gray-900">
        {item?.coin != undefined
          ? `${item.coin}/${item.value}`
          : item.value}
      </p>
    </div >
                  ))
}
                </div >


  {/* Transaction History */ }
  < div className = "bg-white shadow-lg p-5 rounded-xl border-t-4 border-purple-500" >
                  <h2 className="text-lg font-bold text-gray-900 mb-3">
                    Transaction History
                  </h2>
                  <div className="space-y-4">
                    {filteredTransactions.length > 0 ? (
                      filteredTransactions.map((transaction, index) => (
                        <div
                          key={index}
                          className={`bg-gray-100 p-3 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center border-l-4 ${
                            transaction.coin_add_at
                              ? "border-green-600"
                              : "border-red-600"
                          }`}
                        >
                          <div>
                            <h3 className="text-gray-900 font-semibold">
                              {transaction?.heading || "Transaction"}
                            </h3>
                            <p className="text-sm text-gray-600">
                              {transaction?.coin_add_at
                                ? `Credited on ${
                                    transaction?.coin_add_at.split(" ")[0]
                                  }`
                                : `Debited on ${
                                    transaction?.created_at?.split("T")[0] ||
                                    "payout date"
                                  }`}
                            </p>
                          </div>
                          <p
                            className={`text-lg font-bold ${
                              transaction?.coin_add_at
                                ? "text-green-600"
                                : "text-red-600"
                            } mt-2 sm:mt-0`}
                          >
                            {transaction.coin || transaction.amount || "0"}
                          </p>
                        </div>
                      ))
                    ) : (
                      <p className="text-center text-gray-600">
                        No transactions found.
                      </p>
                    )}
                  </div>
                </div >
              </div >
            </div >
          </div >
        </div >
      ) : null}
{ showWithdrawAmountPopUp ? <WithdrawAmount /> : null }
    </>
  );
}

export default YourWallet;
